// ============================================================
// types/seccion.types.ts
// ============================================================

// ── Payload exacto → POST /secciones  y  PUT /secciones/{id} ─
export interface SeccionPayload {
  nombre: string;
  gradoId: number;
  capacidad: number;
  activo: boolean;
}

// ── Estado interno del formulario ─────────────────────────────
export interface SeccionFormState {
  nombre: string;
  gradoId: string;
  capacidad: string;
  activo: boolean;
}

export const SECCION_FORM_INITIAL: SeccionFormState = {
  nombre: '',
  gradoId: '',
  capacidad: '40',
  activo: true,
};
